import { IconProps } from 'src/utils/icon';

const ChevronDownIcon: React.FC<IconProps> = ({ size = 1 }) => (
  <svg
    style={{ fontSize: `${size}rem` }}
    fill="none"
    viewBox="0 0 20 13"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 2l9 8 9-8" stroke="currentColor" strokeWidth="3" />
  </svg>
);

export default ChevronDownIcon;
